import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DataService} from '../../../services/store/data.service';
import {AuthService} from '../../../services/http/auth.service';
import {Authority} from '../../../classes/enums/Authority';
import {ChangeStoreService} from '../../../services/store/change-store.service';
import {StoreSearchComponent} from '../store-search/store-search.component';
import {RuleCheckerComponent} from '../rule-checker/rule-checker.component';

/**
 * This component displays the main navigation header of a page.
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  imports: [CommonModule, RouterModule, StoreSearchComponent, RuleCheckerComponent]
})
export class HeaderComponent implements OnInit {
  dataService = inject(DataService);
  private authService = inject(AuthService);
  private changeStoreService = inject(ChangeStoreService);
  private destroy$ = new Subject<void>();

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** `True` if a user is authenticated. */
  isAuthenticated = false;
  /** A list of actions, the current user is allowed to perform. */
  authorities: Authority[];
  /** Assigns an Authority, so it could be used in HTML. */
  Authority = Authority;

  /**
   * Checks if a user is authenticated and finds a list of actions they are allowed to do.
   */
  ngOnInit(): void {
    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe({
      next: user => {
        this.isAuthenticated = !!user;
        this.authorities = this.isAuthenticated ? user.authorities : [];
      }
    });
  }

  /**
   * Logs out the current user.
   */
  onLogout(): void {
    this.authService.logout();
  }

  /**
   * Checks if the current user has appropriate authority.
   * @param authorities a list of actions, the current user is allowed to perform.
   */
  showPage(...authorities: Authority[]): boolean {
    return this.authorities.some(role => authorities.includes(role));
  }

  /**
   * Unset the selected store.
   */
  unselectStore(): void {
    this.changeStoreService.unselectStore();
  }
}
